import React from 'react';
import SoftTypography from "../../components/SoftTypography";
import SoftBox from "../../components/SoftBox";
import defaultMiniature from "../../assets/images/curved-images/digitization.png";
import SuiButton from "../../components/SoftButton";
import {Checkbox, FormControlLabel, DialogActions, Dialog, DialogTitle, DialogContent, Divider} from "@mui/material";
import {IoClose} from "react-icons/io5";
import CardMedia from "@mui/material/CardMedia";
import PropTypes from 'prop-types';
import {useSoftUIController} from "../../context";
import {useTranslation} from "react-i18next";

function DownloadDigitizedArticleDialog({
                                            isModalOpen,
                                            handleCloseModal,
                                            docData,
                                            selectedFields,
                                            handleFieldChange,
                                            handleGenerateDocument
                                        }) {
    const imageSrc = docData?.picture_path || defaultMiniature;
    const { t } = useTranslation("publicationsTranslation");
    const [controller] = useSoftUIController();
    const {direction} = controller;

    return (
        <>
            <Dialog open={isModalOpen} aria-labelledby="form-dialog-title" maxWidth="sm" fullWidth
                    PaperProps={{style: {borderRadius: 5}}}>
                <DialogTitle
                    id="form-dialog-title"
                    sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: direction === "rtl" ? '1.3rem' : '1.5rem',}}
                >
                    {t("downloadDialogTitle")}
                    <IoClose
                        aria-label="close"
                        onClick={handleCloseModal}
                        style={{
                            position: 'absolute',
                            ...(direction === 'rtl' ? {left: 30} : {right: 30} ),
                            cursor: 'pointer'
                        }}
                    />
                </DialogTitle>
                <Divider/>
                <DialogContent sx={{padding: "0px 24px"}}>

                    <SoftTypography component="div" variant="h6" style={{marginBottom: "20px"}}>
                        <SoftBox>
                            {docData?.title}
                        </SoftBox>
                    </SoftTypography>

                    <div style={{display: "flex"}}>
                        <div>
                            <CardMedia
                                component="img"
                                sx={{width: 150, borderRadius: 0, margin: "0 50px 0 0"}}
                                image={imageSrc}
                                alt="digitized document"
                            />
                        </div>
                        <div>
                            {docData?.digitization_results?.map((digitization_result) => {
                                return (
                                    <FormControlLabel
                                        key={digitization_result}
                                        control={
                                            <Checkbox
                                                checked={selectedFields[digitization_result]}
                                                onChange={() => handleFieldChange(digitization_result)}
                                                sx={{
                                                    mr: (direction === 'rtl' ? 0 : 0.375),
                                                    ml: direction === 'rtl' ? 0.375 : 0,
                                                }}
                                            />
                                        }
                                        label={
                                            <span
                                                style={{
                                                    marginLeft: '0.25rem',
                                                    ...(direction === 'rtl' && {marginLeft: 0, marginRight: '0.25rem'})
                                                }}
                                            >
                                             {t(digitization_result)}
                                            </span>
                                        }
                                    />
                                );
                            })}

                        </div>
                    </div>


                </DialogContent>
                <Divider/>
                <DialogActions>
                    <SuiButton variant="gradient" color="secondary" size="medium"
                               onClick={handleCloseModal}>{t("close")}</SuiButton>
                    <SuiButton variant="gradient" color="primary" size="medium" onClick={handleGenerateDocument}  disabled={Object.values(selectedFields).every(value => value === false)}
                               sx={{ml: 1, mr:  (direction === 'rtl' ? 1 : 0),
                               }}
                    >
                        {t("download")}
                    </SuiButton>
                </DialogActions>
            </Dialog>
        </>
    );
}

DownloadDigitizedArticleDialog.propTypes = {
    isModalOpen: PropTypes.bool,
    handleCloseModal: PropTypes.func,
    selectedFields: PropTypes.shape({
        ocr_text: PropTypes.bool,
        translated_text: PropTypes.bool,
        summary: PropTypes.bool,
        bullet_points_summary: PropTypes.bool,
        description: PropTypes.bool
    }).isRequired,
    docData: PropTypes.object,
    handleFieldChange: PropTypes.func,
    handleGenerateDocument: PropTypes.func
};
export default DownloadDigitizedArticleDialog;